import { AccountActiveMarkIcon, AccountInactiveMarkIcon } from 'assets';

export const AccountActiveDisplay = ({ isAccountActive }: { isAccountActive: boolean }) =>
    isAccountActive ? <AccountActiveMarkIcon /> : <AccountInactiveMarkIcon />;
